export enum TilesModuleLayoutEnum {
  PORTRAIT_LEFT = 'PORTRAIT_LEFT',
  PORTRAIT_RIGHT = 'PORTRAIT_RIGHT',
  LANDSCAPE_LEFT = 'LANDSCAPE_LEFT',
  LANDSCAPE_RIGHT = 'LANDSCAPE_RIGHT'
}

export enum TilesModalLayoutEnum {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE'
}
